import React, { useCallback } from 'react';
import { FluentDropdown } from '../../../../../components/FluentUI/Fluent-Dropdown';
import { makeStyles, shorthands } from '@fluentui/react-components';
import PropTypes from 'prop-types';

const useStyles = makeStyles({
    root: {
        display: "flex",
        padding: "7px",
        ...shorthands.border("1px", "solid", "#EEEEEE"),
        resize: "vertical !important",
        fontSize: "12px !important",
        color: "#4E4E4E",
        height: "36px",
        marginTop: "6px",
        minWidth: "0px",
    },
});

const ProjectPriorityField = React.memo(({
    handleChange,
    priorityValue,
    priorities
}) => {
    const fieldStyle = useStyles();
  
    const onChange = useCallback((e, option) => {
        handleChange('Priority', option.optionText);
    }, [handleChange]);

    return (
        <FluentDropdown
            componentStyle={fieldStyle.root}
            label="Priority"
            size={"small"} 
            defaultValue={priorityValue}
            options={priorities}
            onChange={onChange}
        />
    );
});

ProjectPriorityField.propTypes = {
    handleChange: PropTypes.func.isRequired,
    priorities: PropTypes.array.isRequired,
    priorityValue: PropTypes.string
}

export default ProjectPriorityField;